import { paperStyles } from '@festina-life/ui/libs'
// oxlint-disable-next-line no-restricted-imports - DisclosureSection is allowed in the config portal
import { DisclosureSection } from '@festina-life/ui/listsAndTables'
import cx from 'classnames'
import type { PropsWithChildren } from 'react'

import { Attribute } from '../attribute/Attribute'

type Props = PropsWithChildren<{
  title: string
  count: number
}>

export const ErrorsDisclosure = ({ count, title, children }: Props) => (
  <DisclosureSection
    className="min-w-0 overflow-x-hidden"
    isOpenByDefault={!!count}
  >
    <DisclosureSection.Title
      className={cx(
        'flex gap-x-2 justify-between! w-full rounded-none! text-sm py-0!',
        paperStyles({ isFaded: true, borders: ['all'] }),
      )}
    >
      {title}
      <div className="shrink-0 flex-1" />
      <Attribute className="shrink-0 text-sm">{count}</Attribute>
    </DisclosureSection.Title>

    <DisclosureSection.Body className="pl-2! w-full min-w-0 flex flex-col gap-y-2 pt-2">
      {children}
    </DisclosureSection.Body>
  </DisclosureSection>
)
